<template>
  <div class="col-md-12" v-if="settings">
    <div class="title-heading d-flex justify-content-between">
      <h1>{{ $static('s-api.title', 'Інтеграція') }}</h1>
      <a href="https://ux.im/doc" style="text-decoration: underline;font-size: 22px;">{{ $static('s-api.inst',
        'Інструкція') }}</a>
    </div>
    <div class="panel panel-bordered">
      <div class="row" v-if="apikey">
        <div class="col">
          <div class="form-group" @click="copyBuffer">
            <label class="custom-label">{{ $static('s-api.api_key', 'Api Key') }}</label>
            <input type="text" class="form-control custom-input" placeholder="..." disabled
              :value="settings.env.API_KEY" style="cursor: pointer">
          </div>
        </div>
      </div>
      <div class="button-panel mt-0">
        <button class=" default-btn btn-accent" @click="newKey">
          <span class="text" v-if="!apikey">{{ $static('s-api.nkey', 'Створити ключ') }}</span>
          <span class="text" v-else>{{ $static('s-api.nkeyn', 'Перегенерувати ключ') }}</span>
        </button>
      </div>
    </div>

  </div>
</template>

<script>
import api from '@/api';

export default {
  name: 'SettingsApi',
  components: {},
  data() {
    return {
      template: {},
      settings: {
        public: {},
        env: {}
      }
    }
  },
  mounted() {
    this.fetchSettings();
  },
  computed: {
    apikey() {
      return this.settings && this.settings.env && this.settings.env.API_KEY ? this.settings.env.API_KEY : undefined
    }
  },
  methods: {
    copyBuffer() {
      navigator.clipboard.writeText(this.apikey);
      this.$notify({
        title: this.$static('notify-copy.title', 'Копіювання'),
        text: this.$static('notify.copyed', 'Збережено у буфер'),
        duration: 3000
      });
    },
    makeid(length) {
      let result = '';
      const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
      const charactersLength = characters.length;
      let counter = 0;
      while (counter < length) {
        result += characters.charAt(Math.floor(Math.random() * charactersLength));
        counter += 1;
      }
      return result;
    },
    newKey() {
      this.settings.env.API_KEY = this.makeid(64);
      this.saveSettings();

    },
    fetchSettings() {
      api.get('/api/settings').then(response => response.data).then(data => {
        if (Array.isArray(data.env)) {
          data.env = {}
        }
        this.settings = data;
        this.$store.commit('setSettings', data)
      })
    },

    saveSettings() {
      api.post('/api/settings', { settings: this.settings }).then(response => response.data).then(data => {
        this.$store.commit('setSettings', data);
        this.$notify({
          title: 'Api key',
          text: this.$static('notify.save', 'Збережено.'),
          duration: 3000
        });
      })

    }
  }
}
</script>

<style scoped></style>